<template>
  <nav
    class="navbar navbar-expand navbar-light bg-navbar topbar mb-4 static-top"
  >
    <v-overlay :value="OverlayLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- <button id="sidebarToggleTop" class="btn btn-link rounded-circle mr-3">
      <i class="fa fa-bars"></i>
    </button> -->
    <ul class="navbar-nav ml-auto">
      <!-- <div class="topbar-divider d-none d-sm-block"></div> -->
      <li class="nav-item dropdown no-arrow">
        <a
          class="nav-link dropdown-toggle"
          href="#"
          id="userDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <img
            class="img-profile rounded-circle"
            :src="ProfileImagePath"
            style="max-width: 60px"
          />
          <span class="ml-2 d-none d-lg-inline text-white small">
            {{ DisplayName }}
          </span>
          <span>
            <v-btn class="ml-3" plain @click="UserSessionClear">
              <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
              Logout
            </v-btn>
          </span>
        </a>
        <!-- <div
          class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
          aria-labelledby="userDropdown"
        >
          <a class="dropdown-item" href="#">
            <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
            Profile
          </a>
          <a class="dropdown-item" href="#">
            <i class="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
            Settings
          </a>
          <a class="dropdown-item" href="#">
            <i class="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
            Activity Log
          </a>
          <div class="dropdown-divider"></div>
          <v-btn class="dropdown-item" plain @click="LogoutUser">
            <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
            Logout
          </v-btn>
        </div> -->
      </li>
    </ul>
  </nav>
</template>

<script>
import Common from "@/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [Common],
  data() {
    return {
      ProfileImagePath: "",
      DisplayName: "",
      OverlayLoadingFlag: false,
    };
  },
  methods: {
    UserSessionClear() {
      console.log("UserSessionClear called");

      var role_id = this.$session.get("RoleId");
      role_id = role_id == (null || undefined) ? 0 : role_id;

      if (role_id > 0) {
        this.OverlayLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/users/clear-session";
        var upload = {
          UserInterface: 2,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.OverlayLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            console.log("records=" + JSON.stringify(records));

            if (flag == 1) {
              thisIns.LogoutUser();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
          });
      }
    },
  },
  beforeMount() {
    console.log("top bar menu");
    var user = this.$session.get("user");
    console.log({ user });
    user = user == (null || undefined) ? {} : user;
    console.log({ user });

    var DisplayName = Object.prototype.hasOwnProperty.call(user, "Username")
      ? user.Username
      : "";
    console.log({ DisplayName });
    this.DisplayName = DisplayName;

    var MemberImage = Object.prototype.hasOwnProperty.call(user, "MemberImage")
      ? user.MemberImage
      : "";
    console.log({ MemberImage });
    this.ProfileImagePath = MemberImage;
  },
};
</script>

<style lang="scss" scoped>
</style>